module.exports = __webpack_public_path__ + "img/d6-min.91b93242.png";